module.exports = " <div class=item-tile> <a class=item-tile__top v-link=\"{ name: 'item', params: { itemId: item.uid }}\" v-bind:title=item.title> <h2 class=flush>{{ item.title }}</h2> </a> <div class=\"item-tile__bottom flex\"> <div class=flex style=align-items:center> <span>{{ createdOnFormatted }} </span> </div> </div>  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ItemTile.vue
// module id = 143
// module chunks = 0